export class DefaultEnvironment {
    dev?= false
    mode?: 'dev' | 'test' | 'prod'
    production?= false
    apiUrl: string
    socketUrl: string
    dataDefaultCacheTime?= 60 * 60 * 1000
    trelloPunchListId?= '5d1a6ed72346d86fa682c7fa'
    trelloPunchCheckListName?= 'Punch List Items'
    trelloProdCheckListName?= 'Production'
    defaultEventsLoadingInterval?= 3 * 60 * 1000
    defaultEventShowHintDelay?= 600
    defaultEventHideHintDelay?= 300
    defaultNotificationsUpdateDelay?= 60 * 1000
    googleMapsApiKey?= 'AIzaSyAIhewi58nz6nqc6VHich4aQUZatL7lmMg'
    bottomOfSet?= 30
    errorMesage?= 'Something went wrong'
    systemState: 'Seattle' | 'California'
    systemSeattleUrl: string;
    systemCaliforniaUrl: string;
  systemCartTvUrl: string;

    // from mobile
    timeCard?= {
        maxOvertimePercent: 2
    }

    defaultJobsListLoadingInterval?= 3 * 60 * 1000
};
